const mobileNav = require('./assets/mobileNav')
//const searchForm = require('./assets/searchForm')
//const owlCarousel = require('./assets/owl.carousel')
const headroomNav = require('./assets/headroomNav')
const openFolder = require('./assets/openFolder')
const homeCarousel = require('./assets/homeCarousel')
const css = require('./scss/style.scss')

// mobileNav for responsive navigation
mobileNav()

// Headroom nav for fixed navigation on scroll
headroomNav()

// Open folder script
openFolder()

// Expanding searchFrom on click
//searchForm()

// Homepage carousel
homeCarousel()
